/* InvoicePrint.tsx */
import { Grid, makeStyles, PropTypes, Typography } from '@material-ui/core';
import FlexBox from 'components/FlexBox';
import { format } from 'date-fns';
import React from 'react';
import NumberFormat from 'components/NumberFormat';
import './invoicePrint.css';
import Logo from 'images/NewLogo.jpg';

interface Props {
  invoiceReportPrint: InvoiceReportPrint;
}

const useStyles = makeStyles({
  invoiceList: {
    color: 'black',
    fontSize: '12px',
    margin: 0
  },
  line: {
    borderTop: `1.5px solid black`,
    margin: 0
  },
  pageBreak: {
    pageBreakBefore: 'always'
  }
  // watermax: {
  //   position: 'relative',
  //   height: 'max-content',
  //   margin: 0,
  //   padding: 0,
  //   '&::before': {
  //     position: 'absolute',
  //     content: '""',
  //     opacity: 0.1,
  //     height: '100%',
  //     width: '100vw',
  //     backgroundImage: `url(${Logo})`,
  //     backgroundPosition: '80% 20%',
  //     backgroundRepeat: 'repeat-y',
  //     backgroundSize: '70vw 90vh'
  //   }
  // }
});

const GridFlex = {
  small: 0.25,
  normal: 0.25,
  large: 0.25
};

type tableProperties = {
  key: 'remainingPay' | keyof Required<Pick<InvoiceModel, 'id' | 'orderDate' | 'invoiceNumber' | 'dueDate' | 'totalPrice' | 'totalPay'>>;
  label: string;
  flex: keyof typeof GridFlex;
  align: PropTypes.Alignment;
};

const tableProperties: tableProperties[] = [
  { key: 'orderDate', label: 'Tanggal Invoice', flex: 'small', align: 'left' },
  { key: 'invoiceNumber', label: 'Nomor Invoice', flex: 'large', align: 'left' },
  { key: 'totalPrice', label: 'Jumlah', flex: 'normal', align: 'right' },
  { key: 'totalPay', label: 'Total Bayar', flex: 'normal', align: 'right' },
  { key: 'remainingPay', label: 'Sisa', flex: 'normal', align: 'right' }
];

const InvoicePrint = ({ invoiceReportPrint }: Props) => {
  const classes = useStyles();

  const getTotal = () => {
    const sumTotal = invoiceReportPrint.partners.map(partner =>
      partner.invoices.reduce((total, item) => {
        if (item.status.includes('Return')) {
          return total - (item.totalPrice - item.totalPay);
        }
        return total + (item.totalPrice - item.totalPay);
      }, 0)
    );

    const totalFinal = sumTotal.reduce((total, curr) => total + curr, 0);
    return totalFinal;
  };

  const getTotalPartner = (index: number) => {
    const sumTotal = invoiceReportPrint.partners[index].invoices.reduce((total, item) => {
      if (item.status.includes('Return')) {
        return total - (item.totalPrice - item.totalPay);
      }
      return total + (item.totalPrice - item.totalPay);
    }, 0);

    return sumTotal;
  };

  return (
    <Grid xs={12} container justify='center' style={{ margin: 0, padding: 0 }}>
      {invoiceReportPrint.partners.map((partner, partnerKey) => (
        <FlexBox
          key={partnerKey}
          xs={12}
          container
          rowGap={1}
          direction='row'
          style={{ margin: 0, padding: 0, gap: 0, marginRight: 40, marginTop: 40 }}
          className={partnerKey > 0 ? classes.pageBreak : ''}
        >
          <Grid xs={12}>
            <Typography variant='h5' style={{ fontSize: '12px', margin: 0 }} align='center'>
              LAPORAN - SISA PIUTANG - LANGGANAN
            </Typography>
            <Typography variant='h6' style={{ fontSize: '12px', margin: 0 }} align='center'>
              (SEMUA NOTA)
            </Typography>
            <Typography variant='h6' style={{ fontSize: '12px', margin: 0 }} align='center'>
              Per: {format(new Date(), 'dd-MM-yyyy')}
            </Typography>
            <Typography variant='h6' style={{ fontSize: '12px', margin: 0 }} align='center'>
              Rute: {invoiceReportPrint.zoneName || '-'}
            </Typography>
            <Typography variant='h6' style={{ fontSize: '12px', margin: 0 }} align='center'>
              Customer: {partner.partnerName}
            </Typography>
          </Grid>

          <Grid xs={12} className={classes.line} />
          <FlexBox container rowGap={1} style={{ gap: 0 }}>
            <Grid xs={12} container>
              {tableProperties.map(property => (
                <Grid style={{ flex: GridFlex[property.flex], margin: 0, padding: 0 }} key={property.key}>
                  <Typography variant='h6' style={{ fontSize: '12px', margin: 0 }} align={property.align}>
                    {property.label}
                  </Typography>
                </Grid>
              ))}
            </Grid>
            <Grid xs={12} className={classes.line} />

            {partner.invoices.map((invoice, invoiceKey) => (
              <Grid xs={12} key={invoiceKey} container>
                {tableProperties.map(property => (
                  <Grid style={{ flex: GridFlex[property.flex], margin: 0, padding: 0 }} key={property.key}>
                    {property.key === 'invoiceNumber' ? (
                      <Typography className={classes.invoiceList} align={property.align}>{`#${invoice[property.key]}`}</Typography>
                    ) : property.key === 'orderDate' ? (
                      <Typography className={classes.invoiceList} align={property.align} style={{ marginLeft: '2em' }}>
                        {invoice[property.key] ? format(new Date(invoice[property.key].split(' ')[0]), 'dd MMM yyyy') : '-'}
                      </Typography>
                    ) : property.key === 'remainingPay' ? (
                      <Typography className={classes.invoiceList} align={property.align}>
                        <NumberFormat
                          value={invoice['totalPrice'] - invoice['totalPay']}
                          prefix={invoice['status'].includes('Return') ? '(Rp' : 'Rp'}
                          suffix={invoice['status'].includes('Return') ? ')' : ''}
                          thousandSeparator={true}
                          displayType='text'
                        />
                      </Typography>
                    ) : property.key === 'totalPrice' ? (
                      <Typography className={classes.invoiceList} align={property.align}>
                        <NumberFormat value={invoice['totalPrice']} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                      </Typography>
                    ) : property.key === 'totalPay' ? (
                      <Typography className={classes.invoiceList} align={property.align}>
                        <NumberFormat value={invoice['totalPay']} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                      </Typography>
                    ) : (
                      <Typography className={classes.invoiceList} align={property.align}>
                        {invoice[property.key]}
                      </Typography>
                    )}
                  </Grid>
                ))}
              </Grid>
            ))}
            <FlexBox xs={12} container justify='flex-end' rowGap={1} style={{ gap: 0 }}>
              <Grid xs={8} className={classes.line} />
              <Grid xs={8} container justify='space-between' alignItems='center'>
                <Typography variant='h6' style={{ fontSize: '12px', margin: 0 }}>
                  TOTAL SISA
                </Typography>
                <Typography variant='h6' style={{ fontSize: '12px', margin: 0 }}>
                  <NumberFormat value={getTotalPartner(partnerKey)} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                </Typography>
              </Grid>
            </FlexBox>
          </FlexBox>
        </FlexBox>
      ))}
      {invoiceReportPrint.partners.length > 0 && (
        <FlexBox xs={12} container rowGap={1} style={{ gap: 0 }}>
          <Grid xs={12} className={classes.line} />
          <Grid xs={12} container justify='space-between' alignItems='center'>
            <Typography variant='h6' style={{ fontSize: '12px', margin: 0 }}>
              TOTAL
            </Typography>
            <Typography variant='h6' style={{ fontSize: '12px', margin: 0 }}>
              <NumberFormat value={getTotal()} prefix={'Rp'} thousandSeparator={true} displayType='text' />
            </Typography>
          </Grid>
        </FlexBox>
      )}
    </Grid>
  );
};

export default InvoicePrint;
